import FooterContent from "components/FooterContent";

const Footer = () => {
  return (
    <section className="footer full">
      <div className="footer__content">
        <FooterContent />
      </div>
    </section>
  );
};

export default Footer;
